import {getStore} from 'od-modules/secure_store/store';

const trackingUtils = require('od-modules/utils/tracking.utils');

const LABEL = {
    USER_LOGGED: '-log',
    PAYMENT: {
        DEFAULT: 'pay',
        DP: 'dp-pay',
    },
    FREE_TRIAL: {
        ELIGIBLE: 'user:freetrial_',
        NOT_ELIGIBLE: 'user:expired_',
    },
    PRIME_PAGE: {
        SELECTED: '-add',
        NOT_SELECTED: '-std',
    },
    RESULTS_PAGE: {
        SELECTED: 'prime',
        NOT_SELECTED: 'no-prime',
    },
    PAYMENT_PAGE: {
        SELECTED: 'prime',
        NOT_SELECTED: 'standard',
    },
};

const isDynpack = () => Odigeo.Utils.isRequestApp('dp');

const getPaymentLabel = () => (isDynpack() ? LABEL.PAYMENT['DP'] : LABEL.PAYMENT['DEFAULT']);

const getCCLabel = (secureStore) => {
    const ccStatus = Odigeo._.get(secureStore, 'prime.primeMemberSelected.ccStatus', '');
    return ccStatus === 'validated' ? 'validCC' : 'preCC';
};

const getInPaymentSelectionLabel = (secureStore) => {
    const isSubscriptionAddedLast = Odigeo._.get(secureStore, 'prime.primeMemberSelected.isSubscriptionAdded', false);
    return isSubscriptionAddedLast ? LABEL.PAYMENT_PAGE['SELECTED'] : LABEL.PAYMENT_PAGE['NOT_SELECTED'];
};

const getInResultsSelectionLabel = () => {
    const flightSelectionData = Odigeo.Utils.parseJson(Odigeo.Session.get('flightSelectionData'));
    const isAddedInResults = !Odigeo._.get(flightSelectionData, 'data.priceWithoutDiscountSelected', false) || false;

    return isAddedInResults ? LABEL.RESULTS_PAGE['SELECTED'] : LABEL.RESULTS_PAGE['NOT_SELECTED'];
};

const getInAncillariesSelectionLabel = (secureStore) => {
    const isAddedInAncillaries = Odigeo._.get(secureStore, 'prime.primeMemberSelected.isAddedInAncillaries');
    let ancillariesSelectionLabel = '';
    if (!Odigeo._.isUndefined(isAddedInAncillaries)) {
        ancillariesSelectionLabel = isAddedInAncillaries ? LABEL.PRIME_PAGE['SELECTED'] : LABEL.PRIME_PAGE['NOT_SELECTED'];
    }
    return ancillariesSelectionLabel;
};

const isUserLogged = (secureStore) => {
    const user = Odigeo._.get(secureStore, 'user', true);
    return user && user.email;
};

const getUserLoggedLabel = (secureStore) => {
    return isUserLogged(secureStore) ? LABEL.USER_LOGGED : '';
};

const getEligibilityLabel = (secureStore) => {
    const isFreeTrialEligible = Odigeo._.get(secureStore, 'prime.membershipSubscriptionDetails.freeTrialCandidate', true);
    return isFreeTrialEligible ? LABEL.FREE_TRIAL['ELIGIBLE'] : LABEL.FREE_TRIAL['NOT_ELIGIBLE'];
};
const getUserExtraDiscountSelection = (secureStore) => {
    const DEFAULT_EXTRA_DISCOUNT_SELECTED = {
        wasExtraDiscountAvailable: false,
        wasExtraDiscountSelected: false,
    };

    const primePriceSelectedInResults = Odigeo._.get(secureStore, 'prime.membershipSubscriptionDetails.primePriceSelectedInResults', false);

    const membershipExtraDiscount =
        Odigeo._.get(secureStore, 'prime.membershipSubscriptionDetails.membershipExtraDiscount', DEFAULT_EXTRA_DISCOUNT_SELECTED);
    if (primePriceSelectedInResults) {
        if (!membershipExtraDiscount.wasExtraDiscountAvailable) {
            return 'na';
        }
        if (membershipExtraDiscount.wasExtraDiscountSelected) {
            return 'card';
        }
        return 'none';
    }
    return LABEL.RESULTS_PAGE['NOT_SELECTED'];
};

const getFencedLabel = (secureStore) => {
    return isUserLogged(secureStore) ? 'yes' : 'no';
};

const primePageTracking = function() {
    const secureStore = getStore();
    const userExtraDiscountSelection = getUserExtraDiscountSelection(secureStore);
    const fencedLabel = getFencedLabel(secureStore);
    const isSubscriptionAddedLabel = getInPaymentSelectionLabel(secureStore);
    const category = `flights_prime_page`;
    const action = `prime_extra_discount`;
    const label = `prime-extra-discount_continue:${userExtraDiscountSelection}_selection:${isSubscriptionAddedLabel}_fenced:${fencedLabel}_pag:prime`;
    trackingUtils.trackEventWithCategory(category, action, label);
};

const getTrackingLabel = function(A = '') {
    const secureStore = getStore();
    const paymentSelectionLabel = getInPaymentSelectionLabel(secureStore);
    const userSelectionLabel = `${getInResultsSelectionLabel(secureStore)}${getInAncillariesSelectionLabel(secureStore)}${getUserLoggedLabel(
        secureStore
    )}`;
    const userEligibleLabel = getEligibilityLabel(secureStore);
    const pagLabel = getPaymentLabel();
    const ccStatus = getCCLabel(secureStore);
    const userExtraDiscountSelection = getUserExtraDiscountSelection(secureStore);
    const fencedLabel = getFencedLabel(secureStore);

    const TRACKING_LABEL = {
        onLoadSummarySection: `prime_widget_sce:${userSelectionLabel}_${userEligibleLabel}pag:${pagLabel}`,
        expandSummaryPrimeWidget: `expand_prime_widget_sce:${userSelectionLabel}_pag:${pagLabel}`,
        reduceSummaryPrimeWidget: `reduce_prime_widget_sce:${userSelectionLabel}_pag:${pagLabel}`,
        editSummaryPrimeWidget: `edit_prime_sce:${userSelectionLabel}_${userEligibleLabel}pag:${pagLabel}`,
        closePrimeWidgetEdit: `edit_prime_close_sce:${userSelectionLabel}_${userEligibleLabel}pag:${pagLabel}`,
        changePassengerPrimeWidgetEdit: `change_prime_pax_${A}_sce:${userSelectionLabel}_${userEligibleLabel}pag:${pagLabel}`,
        openRemovePrimeWidgetEdit: `remove_prime_sce:${userSelectionLabel}_${userEligibleLabel}pag:${pagLabel}`,
        closeRemovePrimeWidgetEdit: `remove_prime_close_sce:${userSelectionLabel}_${userEligibleLabel}pag:${pagLabel}`,
        submitRemovePrimeWidgetEdit: `remove_prime_confirm_sce:${userSelectionLabel}_${userEligibleLabel}pag:${pagLabel}`,
        cancelRemovePrimeWidgetEdit: `remove_prime_cancel_sce:${userSelectionLabel}_${userEligibleLabel}pag:${pagLabel}`,
        onLoadAddSubscriptionBox: `prime_widget_sce:${userSelectionLabel}_${userEligibleLabel}pag:${pagLabel}`,
        addPrimeAddPrimeWidget: `add_prime_sce:${userSelectionLabel}_${userEligibleLabel}pag:${pagLabel}`,
        onPrimeAddedInPayment: `prime_widget_add-prime_confirmation-${ccStatus}_sce:${userEligibleLabel}_pag:${pagLabel}`,
        onPrimeRiskCardDetected: `prime_widget_add-prime_fail-${ccStatus}_sce:${userEligibleLabel}_pag:${pagLabel}`,
        knowMoreAddPrimeWidget: `know_more_widget_sce:${userSelectionLabel}_${userEligibleLabel}pag:${pagLabel}`,
        closeKnowMoreFlightsPrimeLightbox: `know_more_widget_close_sce:${userSelectionLabel}_pag:${pagLabel}`,
        continuePaymentButton: `continue_with_${paymentSelectionLabel}_sce:${userSelectionLabel}_${userEligibleLabel}pag:${pagLabel}`,
        primeExtraDiscountContinuePaymentButton: `prime-extra-discount_continue:${userExtraDiscountSelection}_fenced:${fencedLabel}_pag:${pagLabel}`,
        primeExtraDiscountContinuePrimePageButton: `prime-extra-discount_continue:${userExtraDiscountSelection}_fenced:${fencedLabel}_pag:prime`,
    };
    return TRACKING_LABEL;
};

const revampTrackingLabel = function(labelFrom, A = '') {
    const TRACKING_LABEL = getTrackingLabel(A);

    revampPaymentTracking(labelFrom, `${TRACKING_LABEL[labelFrom]}`);
};

const revampPaymentTracking = function(labelFrom, label) {
    const categories = isDynpack() ? ['dynpack_pay_page', 'dynpack_prime_lightbox'] : ['flights_pay_page', 'flights_prime_lightbox'];
    const actions = ['prime', 'prime_widget', 'prime_widget_edit', 'prime_lightbox', 'prime_extra_discount'];
    const description = labelFrom.replace(/([A-Z])/g, '_$1').toLowerCase();
    const category = filterInDescription(categories, description);
    const action = filterInDescription(actions, description);

    trackingUtils.trackEventWithCategory(category, action, label);
};

const filterInDescription = function(arrayToFind, description) {
    const result = arrayToFind.filter((item) => description.indexOf(item) !== -1);
    return result[result.length - 1] || arrayToFind[0];
};

export default {
    revampTrackingLabel,
    primePageTracking,
};
